import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FrontendConfig} from '@npck/auth-frontend-api';
import {AppConfigService, LocalizationService} from '@npck/libs/commons';
import {AuthHolderService} from '../../domain/auth-holder.service';

export enum FinishPageReason {
    AUTO_EXCHANGE_TOKEN = 'AUTO_EXCHANGE_TOKEN',
    AUTHORITY_MATRIX_ACCEPTED = 'AUTHORITY_MATRIX_ACCEPTED',
    AUTHORITY_MATRIX_REJECTED = 'AUTHORITY_MATRIX_REJECTED',
    AUTHORITY_MATRIX_DEACTIVATED = 'AUTHORITY_MATRIX_DEACTIVATED',
    AUTHORITY_MATRIX_DEACTIVATION_REJECTED = 'AUTHORITY_MATRIX_DEACTIVATION_REJECTED',
}

const TITLES = new Map<string, string>([
    [FinishPageReason.AUTO_EXCHANGE_TOKEN, 'i18n_auth_autoExchangeFinishTitle'],
    [FinishPageReason.AUTHORITY_MATRIX_ACCEPTED, 'i18n_auth_finishAuthTitleAuthorityMatrixAccepted'],
    [FinishPageReason.AUTHORITY_MATRIX_REJECTED, 'i18n_auth_finishAuthTitleAuthorityMatrixRejected'],
    [FinishPageReason.AUTHORITY_MATRIX_DEACTIVATED, 'i18n_auth_finishAuthTitleAuthorityMatrixDeactivated'],
    [FinishPageReason.AUTHORITY_MATRIX_DEACTIVATION_REJECTED, 'i18n_auth_finishAuthTitleAuthorityMatrixDeactivationRejected'],
]);

const DESCRIPTIONS = new Map<string, string>([
    [FinishPageReason.AUTO_EXCHANGE_TOKEN, 'i18n_auth_autoExchangeFinishDescription'],
    [FinishPageReason.AUTHORITY_MATRIX_ACCEPTED, 'i18n_auth_finishAuthDescriptionAuthorityMatrixAccepted'],
    [FinishPageReason.AUTHORITY_MATRIX_REJECTED, 'i18n_auth_finishAuthDescriptionAuthorityMatrixRejected'],
    [FinishPageReason.AUTHORITY_MATRIX_DEACTIVATED, 'i18n_auth_finishAuthDescriptionAuthorityMatrixDeactivated'],
    [FinishPageReason.AUTHORITY_MATRIX_DEACTIVATION_REJECTED, 'i18n_auth_finishAuthDescriptionAuthorityMatrixDeactivationRejected'],
]);

const ICONS = new Map<string, string>([
    [FinishPageReason.AUTO_EXCHANGE_TOKEN, 'ic_document_signed'],
    [FinishPageReason.AUTHORITY_MATRIX_ACCEPTED, 'ic_succeeded'],
    [FinishPageReason.AUTHORITY_MATRIX_REJECTED, 'ic_rejected'],
    [FinishPageReason.AUTHORITY_MATRIX_DEACTIVATED, 'ic_succeeded'],
    [FinishPageReason.AUTHORITY_MATRIX_DEACTIVATION_REJECTED, 'ic_warning'],
]);

@Component({
    templateUrl: 'finish.component.html',
    styleUrls: ['finish.component.scss'],
    standalone: false,
})
export class FinishComponent {
    reason: any;
    requestId: string;
    title: string;
    description: string;
    icon: string;
    env: string = AppConfigService.config<FrontendConfig>().env;
    additionalParams: Record<string, any>;
    language: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private oauthHolderService: AuthHolderService,
        private localizationService: LocalizationService,
    ) {
        this.reason = this.activatedRoute.snapshot.queryParams.reason;
        this.title = TITLES.get(this.reason);
        this.description = DESCRIPTIONS.get(this.reason);
        this.icon = ICONS.get(this.reason);

        this.language = localizationService.currentLanguage.locale;
        localizationService.language$.subscribe((language) => {
            this.language = language.locale;
            this.additionalParams = {
                externalOrgName: this.language === 'ru' ?
                    this.oauthHolderService.externalOrgNameRu :
                    this.oauthHolderService.externalOrgNameKk,
            };
        });
        this.additionalParams = {
            externalOrgName: this.language === 'ru' ?
                this.oauthHolderService.externalOrgNameRu :
                this.oauthHolderService.externalOrgNameKk,
        };
    }

    get userCabinetUrl(): string {
        if (this.env === 'prod') {
            return 'https://id.npck.kz/user';
        }
        if (['stage', 'test', 'dev'].includes(this.env)) {
            return `https://id.${this.env}.npck.kz/user`;
        }
        return 'http://localhost:4202/user';
    }

    onGoToCabinet(): void {
        window.location.replace(this.userCabinetUrl);
    }
}
